import axios from "axios";
import { Company } from "../models/company.model";
import store from "../store/store";
import { BaseService } from "./base.service";

class CompanyService extends BaseService{

    constructor() {
        super();
        console.log("created a instance of companyService");
    }

    async delete(id: string){
        let result = await axios.delete(`${this.api}company/${id}`);
        return result;
        // return this.execute('delete', `company/${id}`);
    }

    async getAll(){
        return axios.get(`${this.api}company/`).then(req => { return req.data });
        // return this.execute('get', 'company/');
    }

    async get(id: string){
        return axios.get(`${this.api}company/GetCompany?id=${id}`).then(req => { return req.data });
        // return this.execute('get', `company/${id}`);
    }

    // async getByKey(companyKey: string){
    //     return axios.get(`${this.api}company/key/${companyKey}`).then(req => { return req.data });
    //     // return this.execute('get', `company/${id}`);
    // }

    async create(company: Company){
        let result = await axios.post(`${this.api}company/`, company);
        return result;
        // return this.execute('post', `company/`, company);
    }

    async update(company: Company){
        let result = await axios.put(`${this.api}company/${company.id}`, company);
        return result;
        // return this.execute('put', `company/${company.id}`, company);
    }

    async createImage(formData:FormData, companyId:string){
        return axios.post(`${this.api}company/CreateImage/?companyId=${companyId}`,
        formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        ).then(req => { return req.data });
    }

    async updateImage(formData:FormData, companyId:string){
        return axios.put(`${this.api}company/UpdateImage/?companyId=${companyId}`,
        formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        ).then(req => { return req.data });
    }
}

export const companyService = new CompanyService();

